import { useState } from "react"
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "./command"
import { Popover, PopoverContent, PopoverTrigger } from "./popover"
import { Check, ChevronsUpDown } from "lucide-react"
import { cn } from "@/lib/utils"
import { Button } from "./button"
import { Badge } from "./badge"

export interface ComboboxOption {
  label: string
  value: string
  description?: string
  badge?: string
}

interface ComboboxProps {
  children?: React.ReactNode
  options?: ComboboxOption[]
  value?: string
  onChange?: (value: string) => void
  onValueChange?: (value: string) => void
  placeholder?: string
  searchPlaceholder?: string
  optionsGroups?: { label: string; options: ComboboxOption[] }[]
  className?: string
  after?: React.ReactNode
  fluid?: boolean
  onOpenChange?: (open: boolean) => void
  loading?: boolean
}

interface ComboboxGroupProps {
  label?: string
  options?: ComboboxOption[]
}

function ComboboxGroup(
  props: ComboboxGroupProps & {
    setOpen: (open: boolean) => void
    onChange?: (value: string) => void
    onValueChange?: (value: string) => void
    value?: string
  },
) {
  return (
    <CommandGroup key={props.label}>
      {props.label && <label className="px-2 py-1.5 text-xs text-secondary">{props.label}</label>}
      {props.options?.map((option) => (
        <CommandItem
          key={option.value}
          value={option.label + " " + option.description}
          onSelect={() => {
            props.onChange?.(option.value)
            props.onValueChange?.(option.value)
            props.setOpen(false)
          }}
        >
          <div className="flex flex-col">
            <span className="text-sm font-medium">
              {option.label}{" "}
              {option.badge && (
                <Badge
                  variant="outline"
                  // className="ml-2 px-[5px] py-[1px] text-[9px] uppercase font-bold rounded-full bg-amber-200"
                  className="ml-2 px-[5px] py-[1px] text-[9px] uppercase font-bold rounded-full"
                >
                  {option.badge}
                </Badge>
              )}
            </span>
            {option.description && <span className="text-[11px] text-secondary">{option.description}</span>}
          </div>
          <Check className={cn("ml-auto", props.value === option.value ? "opacity-100" : "opacity-0")} />
        </CommandItem>
      ))}
    </CommandGroup>
  )
}

function Combobox(props: ComboboxProps) {
  const [_open, _setOpen] = useState(false)

  const open = _open
  const setOpen = (o: boolean) => {
    _setOpen(o)
    props.onOpenChange?.(o)
  }

  const allOptions = [...(props.optionsGroups?.flatMap((group) => group.options) || []), ...(props.options || [])]

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        {/* <Button variant="outline" role="combobox" aria-expanded={open} className="w-[200px] justify-between">
          {value ? frameworks.find((framework) => framework.value === value)?.label : "Select framework..."}
          <ChevronsUpDown className="opacity-50" />
        </Button> */}
        {props.children || (
          <Button variant="outline" role="combobox" aria-expanded={open} className="w-full justify-between font-normal text-sm">
            {props.value ? (
              allOptions.find((option) => option.value === props.value)?.label
            ) : (
              <span className="text-secondary">{props.placeholder}</span>
            )}
            <ChevronsUpDown className="opacity-50 size-4" />
          </Button>
        )}
      </PopoverTrigger>
      <PopoverContent className={cn("p-0", props.className, props.fluid && "w-[var(--radix-popover-trigger-width)]")}>
        {/* <PopoverContent className=""> */}
        <Command>
          <CommandInput placeholder={props.searchPlaceholder ?? "Search..."} className="h-9" />
          <CommandList>
            <CommandEmpty>No option found.</CommandEmpty>
            {(props.options || [])?.length > 0 && (
              <ComboboxGroup
                options={props.options}
                setOpen={setOpen}
                onChange={props.onChange}
                onValueChange={props.onValueChange}
                value={props.value}
              />
            )}
            {/* <CommandGroup>
              {props.options?.map((option) => (
                <CommandItem
                  key={option.value}
                  value={option.label + " " + option.description}
                  onSelect={() => {
                    props.onChange?.(option.value)
                    setOpen(false)
                  }}
                >
                  <div className="flex flex-col">
                    <span className="text-sm font-medium">{option.label}</span>
                    {option.description && <span className="text-[11px] text-secondary">{option.description}</span>}
                  </div>
                  <Check className={cn("ml-auto", props.value === option.value ? "opacity-100" : "opacity-0")} />
                </CommandItem>
              ))}
            </CommandGroup> */}
            {props.optionsGroups?.map((group) => (
              <ComboboxGroup
                key={group.label}
                label={group.label}
                options={group.options}
                setOpen={setOpen}
                onChange={props.onChange}
                onValueChange={props.onValueChange}
                value={props.value}
              />
              // <CommandGroup key={group.label}>
              //   <label className="px-2 py-1.5 text-xs text-secondary">{group.label}</label>
              //   {group.options.map((option) => (
              //     <CommandItem
              //       key={option.value}
              //       value={option.label + " " + option.description}
              //       onSelect={() => {
              //         props.onChange?.(option.value)
              //         setOpen(false)
              //       }}
              //     >
              //       <div className="flex flex-col">
              //         <span className="text-sm font-medium">{option.label}</span>
              //         {option.description && <span className="text-[11px] text-secondary">{option.description}</span>}
              //       </div>
              //       <Check className={cn("ml-auto", props.value === option.value ? "opacity-100" : "opacity-0")} />
              //     </CommandItem>
              //   ))}
              // </CommandGroup>
            ))}
          </CommandList>
          {props.after}
        </Command>
      </PopoverContent>
    </Popover>
  )
}

export default Combobox
